var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: { title: _vm.$t("details"), visible: _vm.dialogShow },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { width: "750px" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.reqLoading,
                      expression: "reqLoading"
                    }
                  ],
                  attrs: { data: _vm.tableData, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "game", label: _vm.$t("game"), width: "140" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "platform",
                      label: _vm.$t("platform"),
                      width: "120"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "channel", label: _vm.$t("channel") }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "pkg", label: _vm.$t("pkg"), width: "170" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "server_id",
                      label: _vm.$t("serverId"),
                      width: "130"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "role_id",
                      label: _vm.$t("roleId"),
                      width: "130"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "role_name",
                      label: _vm.$t("roleName"),
                      width: "130"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "league_id",
                      label: _vm.$t("guildId"),
                      width: "130"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "league_name",
                      label: _vm.$t("guildName"),
                      width: "130"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "level", label: _vm.$t("level") }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fighting",
                      label: _vm.$t("fightingPower"),
                      width: "130"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "last_login_ip",
                      label: _vm.$t("lastLoginIp"),
                      width: "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "last_login_time",
                      label: _vm.$t("lastLoginTime"),
                      width: "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remain_coin",
                      label: _vm.$t("remainingCoin")
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remain_diamond",
                      label: _vm.$t("remainingDiamond")
                    }
                  })
                ],
                1
              ),
              _vm.tableData.length
                ? _c("el-pagination", {
                    attrs: {
                      layout: "total,sizes, prev, pager, next",
                      "current-page": _vm.paramsData.page,
                      total: _vm.total
                    },
                    on: {
                      "size-change": _vm.sizeChange,
                      "current-change": _vm.getList
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("confirm")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }